/**
 * Specifies all supported file-type
 */
export enum SupportedFileTypeEnum {
  GENERAL_IMAGE = "image/*",
  KNX_PROJ = ".knxproj",
  CONFIG = ".config",
}
